export const GOOGLE_MAP = "GOOGLE_MAP";